import React from 'react'

const BasicFunctional = ({name}) => {

	return (
		<h1>Hello, {name}</h1>

	);


}

export default BasicFunctional;


// WEBPACK FOOTER //
// ./src/components/BasicFunctional.js